import { API_URL, API_ZONES } from "../ApiPaths";

/** TEAM */
export const getZones = async () => {
  const res = await fetch(API_URL + API_ZONES, {
    method: "GET",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
  });
  if (!res.ok) {
    throw new Error("Network response was not ok");
  }
  return res.json();
};

export const addNewZone = async (tmpNew: string) => {
  const res = await fetch(API_URL + API_ZONES, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ name: tmpNew }),
  });

  if (!res.ok) {
    throw new Error("Network response was not ok");
  }

  return res.json();
};

export const deleteZone = async (id: string) => {
  const res = await fetch(`${API_URL}${API_ZONES}/${id}`, {
    method: "DELETE",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
  });

  if (!res.ok) {
    throw new Error("Network response was not ok");
  }

  return res.json();
};
